import { SelectOption } from '@doveit/bricks';
import { JobApplicationStatus, koJobApplicationStatus } from '../../../domain/types/jobApplicationStatus';
import { jobApplicationStatusLabels } from '../../../labels';
import { computeAllowedJobApplicationStatusUpdates } from '../../hooks/use-computed-job-application-status/useComputedJobApplicationStatus';

export const koReasonOptions = (isAdminOrHR: boolean, isAssignedAgent: boolean, status: JobApplicationStatus): SelectOption[] => {
  const allowed = computeAllowedJobApplicationStatusUpdates(isAdminOrHR, isAssignedAgent, status);
  const koOptions = allowed.filter((s) => koJobApplicationStatus.includes(s));

  return koOptions.length === 0 ? [] : [
    {
      value: '',
      label: 'Seleziona una motivazione',
    },
    ...koOptions.map((key) => ({
      value: key,
      label: jobApplicationStatusLabels[key as JobApplicationStatus],
    })),
  ];
};
